import { useI18n } from '@cascade/react/i18n';
import { Link, Text } from '@cascade/ui-library';
import { SUPPORT_EMAIL } from '#config/index.ts';

export const SupportContact = () => {
  const { translate } = useI18n();

  const email = (
    <Link
      label={SUPPORT_EMAIL}
      uri={`mailto:${SUPPORT_EMAIL}`}
      target='self'
      textProps={{ type: 'caption' }}
    />
  );

  return (
    <Text
      type='caption'
      color='text-60'
      content={translate('support.prompt', { email })}
    />
  );
};
